import { GridPageHeader } from "src/components/Grid/PageGridHeader";
import { useTranslation } from "react-i18next";
import { SupplierGrid } from "./SuppliersList/SuppliersGrid";
import { SupplierListContextProvider, useSupplierListContext } from "./SuppliersList/SupplierListContext";
import { useMemo } from "react";
import { SupplierPopover } from "./SuppliersList/Popover/SupplierPopover";
import { EXTENSION_POINTS, ExtensionPoint } from "src/components/PuckExtensions";
import { EntityListLayout } from "src/components/Grid/EntityListLayout";
import { useIsProductUxV2 } from "src/hooks/useIsProductUxV2";

const SuppliersListComponent = () => {
    const { t } = useTranslation();
    const isProductUxV2 = useIsProductUxV2();
    const { globalSearch } = useSupplierListContext();
    const { search, setSearch } = globalSearch;
    const title = t("fournisseurs");

    const SupplierGridMemo = useMemo(() => {
        return <SupplierGrid />;
    }, []);

    return (
        <EntityListLayout
            appearance={isProductUxV2 ? "hub" : "legacy"}
            heading={<GridPageHeader title={title} />}
            ariaLabel={title}
            search={{
                value: search,
                onChange: setSearch,
                placeholder: t("rechercher_un_element"),
                showOnDesktop: false,
            }}
            actions={<SupplierPopover />}
            beforeGrid={<ExtensionPoint extensionPoint={EXTENSION_POINTS.SUPPLIER_LISTING_HEADER} priority="high" />}
            afterGrid={<ExtensionPoint extensionPoint={EXTENSION_POINTS.SUPPLIER_LISTING_FOOTER} priority="high" />}
            hideHeadingOnMobile
        >
            {SupplierGridMemo}
        </EntityListLayout>
    );
};

export const SuppliersList = () => {
    const isProductUxV2 = useIsProductUxV2();

    return (
        <SupplierListContextProvider appearance={isProductUxV2 ? "product-v2" : "legacy"}>
            <SuppliersListComponent />
        </SupplierListContextProvider>
    );
};
